// Global
import React from 'react';

// Lib
import { UserProfile } from 'src/.generated/UserProfile/ForgotPassword.model';
import ForgotPassword from './ForgotPassword';
import { useRichTextWrapper } from 'components/helpers/SitecoreWrappers/RichTextWrapper/RichTextWrapper';
import { usePlainTextWrapper } from 'components/helpers/SitecoreWrappers/PlainTextWrapper/PlainTextWrapper';
import { useLinkWrapper } from 'components/helpers/SitecoreWrappers/LinkWrapper/LinkWrapper';
import styles from './ForgotPassword.module.scss';

type ForgotPasswordSitecoreProps = UserProfile.ForgotPassword.ForgotPassword_Component;

export const Default = ({ fields }: ForgotPasswordSitecoreProps): JSX.Element => {
  const {
    forgotPasswordTitle,
    forgotPasswordDescription,
    signupLink,
    submitButtonText,
    successMessage,
    emailPlaceholderText,
    cancelButton,
    emailAddressLabel,
    notAMemberText,
  } = fields || {};

  const titleNode = usePlainTextWrapper({ field: forgotPasswordTitle });
  const descriptionNode = useRichTextWrapper({ field: forgotPasswordDescription });

  const signupLinkNode = useLinkWrapper({
    field: signupLink,
    ctaStyle: 'link',
    ctaVariant: 'brand',
    className: styles.signupLink,
  });
  const cancelLinkNode = useLinkWrapper({
    field: cancelButton,
    ctaStyle: 'outline',
    ctaVariant: 'brand',
    className: styles.cancelLink,
  });
  const emailAddressLabelNode = usePlainTextWrapper({ field: emailAddressLabel });
  const notAMemberTextNode = usePlainTextWrapper({ field: notAMemberText });
  const successMessageNode = useRichTextWrapper({ field: successMessage });
  const submitButtonTextNode = usePlainTextWrapper({ field: submitButtonText });

  if (!fields) {
    return <></>;
  }

  return (
    <ForgotPassword
      title={titleNode}
      description={descriptionNode}
      emailPlaceholderText={emailPlaceholderText?.value || ''}
      signupLink={signupLinkNode}
      cancelLink={cancelLinkNode}
      emailAddressLabel={emailAddressLabelNode}
      submitButtonText={submitButtonTextNode}
      successMessage={successMessageNode}
      notAMemberText={notAMemberTextNode}
    />
  );
};
